const commonStyles = {
  fontSize: '1rem',
  fontFamily: 'inherit',
  fontWeight: 'inherit',
  lineHeight: '1.4',
  margin: '0',
  padding: '0',
  color: '#0F172A',
  display: 'block',
  position: 'initial',
  width: 'auto',
  boxSizing: 'border-box',
};

export const getContainerStyles = (color) => ({
  ...commonStyles,
  '--action-style-color': color,
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '0.4rem',
  alignItems: 'flex-start',
  textAlign: 'left',
  margin: '1rem 0',
  maxWidth: '34rem',
});

export const labelStyles = {
  ...commonStyles,
  flexBasis: '100%',
  overflow: 'visible',
  transform: 'none',
  whiteSpace: 'normal',
  fontFamily: '"Outfit", "DM Sans", sans-serif',
  fontWeight: 700,
  marginBottom: '0.2em',
  fontSize: 'clamp(1.45rem, 1.1rem + 0.9vw, 1.9rem)',
  lineHeight: 1.16,
  letterSpacing: '-0.02em',
  transition: 'color 100ms',
  '&.Mui-focused': {
    color: 'var(--action-style-color)',
  },
};

export const inputStyles = {
  ...commonStyles,
  flexBasis: '100%',
  maxWidth: '100%',
  'label + &': {
    marginTop: '0',
  },
  '&.MuiInputBase-adornedEnd': {
    position: 'relative',
    '& > input': {
      paddingRight: '2.5em',
    },
    '.MuiInputAdornment-root': {
      position: 'absolute',
      right: '0.75em',
      top: '50%',
      transform: 'translateY(-50%)',
      '.MuiButtonBase-root': {
        color: '#64748B',
        border: 'solid 2px transparent',
        transition: 'color 100ms, border 100ms',
        '&:focus, &:hover': {
          color: '#0F172A',
        },
        '&:focus': {
          borderColor: 'var(--action-style-color)',
        },
      },
    },
    '.MuiSvgIcon-root': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  '& > input': {
    ...commonStyles,
    height: 'auto',
    textAlign: 'left',
    background: 'linear-gradient(90deg, #F1F5F9 0%, rgba(241, 245, 249, 0.4) 100%)',
    padding: '0.72em 0.9em',
    borderRadius: '14px',
    color: '#0F172A',
    width: '100%',
    outline: 'solid 0.0625em var(--action-style-color)',
    transition: 'outline-width 100ms',
    '&:focus': {
      outline: 'solid 0.125em var(--action-style-color)',
    },
  },
};

export const helperTextStyles = {
  ...commonStyles,
  fontFamily: '"DM Sans", sans-serif',
  color: '#64748B',
  fontSize: '1rem',
  fontWeight: 400,
  marginTop: '0.5em',
  flexBasis: '100%',
  '&.Mui-focused': {
    color: '#0F172A',
  },
};
